GP.GPMod('TrialUpgrade',function(self){
    var vent   = null;
    var common = null;
    var _log   = null;

    var data = {
        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            common = self.app.Util;
            _log   = self.app.Util.log;
        }
    };

    var gui = {
        init: function() {
            this.$btn_upgrade = $('.btn-upgrade-trial');
        }
    };

    var apis = {
        upgrade_trial: function() {
            $.post('/members/billing/trial_upgrade_modal', {
                process: 1,
            })
            .done(function(json) {
                if (json.success) {
                    events.show_success();
                } else if (json.error) {
                    events.show_errow(json.error);
                }
            });
        },
    };

    var events = {
        init: function() {

        },
        setup_binds: function() {
            // setup jquery selectors
            gui.init();
        },
        setup_trial_upgrade_modal: function() {
            events.setup_binds();
            gui.$btn_upgrade.on('click', function() {
                $(this).addClass('disabled');
                apis.upgrade_trial();
            });
        },
        show_success: function() {
            gui.$btn_upgrade.removeClass('disabled').hide();
            $('.trial-upgrade-modal .btn-cancel').hide();
            $('.trial-upgrade-modal .alert-success').show();
            $('.trial-upgrade-modal .btn-done').show();

            GP.sdata.my_user.unconverted_trial = false;
            $('.trial-upgrade-offer-wrap .btn-trial-offer-close').click();
        },
        show_errow: function(text_error) {
            $('.trial-upgrade-modal .alert-error')
            .text(text_error)
            .show()
            .delay(8000)
            .fadeOut();
            gui.$btn_upgrade.removeClass('disabled');
        }
    };

    this.addInitializer(function(){
        data.init();
        events.init();

        self.vent.on(self.moduleName+":setup_trial_upgrade_modal", events.setup_trial_upgrade_modal, this);
    });
});
